const { io } = require('./ioHandler');
const { initGame } = require('./client');
import Push from 'push.js'
const usePushNotif = true;

const { reactRender } = require('./reactRender');

const botsMessage = "Start game vs bots >";
const returnToNormalQueueMessage = "Play against ranked bot >";

function rankedGameInBackground(clickBack) {
  io.emit('searchInBackground', { });
  clickBack();
  io.emit('findGame', { ranked: false });
  io.emit('findGameNow', { ranked: false });

  const topButton = function(nuthin, ranked) {
    if (ranked)
      returnToMatchmaking(clickBack, true);
    else
      rankedGameInBackground(clickBack)
  }

  const bottomButton = function(ranked) {
    if (ranked)
      clickBack();
    else
      returnToMatchmaking(clickBack, true)
  }

  initGame(false, bottomButton, topButton, "Play another unranked game", true);
}

function returnToMatchmaking(clickBack, isRanked) {
  io.emit('findGame', { ranked: isRanked });
  initMatchmaking(clickBack, isRanked);
}

function showStartBotGameUI(inClickBack) {

  console.log("showStartBotGameUI(inClickBack)");
  
  reactRender.startBotGame(inClickBack, (numBots, botLevel) => {
    console.log("createBotGame numBots: " + numBots + ", botLevel: " + botLevel);
    
    io.emit('createBotGame', { numBots: numBots, botLevel: botLevel });    
    initGame(false, inClickBack, returnToMatchmaking);
  });
}

var foundGame = 0;
var inSearch = false;
var isSearchRanked = false;
function initMatchmaking(inClickBack, isRanked) {

  isSearchRanked = isRanked;
  var timeStartMatchmaking = Date.now();
  inSearch = true;

  var clickBack = (backToMainMenu = true) => {
    io.off('matchMade');
    io.off('alertFoundGame');
    inSearch = false;
    foundGame = 0;
    if (backToMainMenu)
      inClickBack();
  }

  if (isRanked) {
    var checkShowAis = function() {

      if (inSearch && isSearchRanked == isRanked) {
        console.log("checkShowAis", Date.now() - timeStartMatchmaking);

        if (isSearchRanked && Date.now() > timeStartMatchmaking + 1000 && foundGame == 0)
          reactRender.search(inClickBack, "Searching...", 
            () => { rankedGameInBackground(clickBack, isRanked); },
            () => { clickBottomLink(clickBack, isRanked); },
            isRanked ? returnToNormalQueueMessage : botsMessage, isRanked);
        else
          setTimeout(checkShowAis, 2 * 1000);
      }
    }
    setTimeout(checkShowAis, 2 * 1000);
  }


  constructMatchmakingHTML(clickBack, "Searching...", isRanked);
  io.on('matchMade', () => {
    foundGame = 0;
    inSearch = false;
    endMatchmaking(clickBack);
    initGame(false, clickBack, returnToMatchmaking);
  })

  io.on('alertFoundGame', (msg) => {
  
    var sound = document.getElementById("alert");
    sound.volume = 0.115;
    sound.play();

    foundGame++

    setTimeout(() => { 
      if (foundGame > 0) {
        foundGame--;
        if (foundGame == 0) {
          reactRender.search(inClickBack, "Searching...", 
            () => { rankedGameInBackground(clickBack, isRanked); },
            () => { clickBottomLink(clickBack, isRanked); },
            isRanked ? returnToNormalQueueMessage : botsMessage, isRanked);

          reactRender.animation();
        }
      }
    }, 4 * 1000);

    constructMatchmakingHTML(clickBack, "Joining a " + msg.players + " player game... (" + msg.time + ")", isRanked);
    reactRender.animation();
  });
}

function clickBottomLink(clickBack, isRanked) {
  
  if (isRanked)
    clickRankedBot(clickBack);
  else {
    clickBack(); 
    showStartBotGameUI(clickBack);
  }
}

function clickRankedBot(clickBack) {
  io.emit('rankedBotGame', { });
  initGame(false, clickBack, returnToMatchmaking);
}

function constructMatchmakingHTML(clickBack, message, isRanked) {
  if (usePushNotif)
    Push.Permission.request();
  reactRender.search(clickBack, message, null, () => { clickBottomLink(clickBack, isRanked); }, isRanked ? returnToNormalQueueMessage : botsMessage, isRanked);
}

function endMatchmaking(clickBack) {

  io.off('matchMade');
  io.off('alertFoundGame');
  reactRender.nothing(clickBack);

  if (usePushNotif && !document.hasFocus())
  {
    Push.create("Traitors.sh", {
        body: "Game Found",
        icon: 'resources/icon.jpg',
        timeout: 4000,
        onClick: function () {
            window.focus();
            this.close();
        }
    });
  }
  
}

module.exports = {
  initMatchmaking,
  showStartBotGameUI,
}
